import type { Condition } from '../types/conditions';
import type { FormFieldMapping } from '../types/fieldMapping';
import { prefixCondition } from '../processors/pathRewriter';

function maybePrefixWhenClause(
  clause: boolean | Condition | undefined,
  namePrefix: string,
): boolean | Condition | undefined {
  if (clause === undefined || typeof clause === 'boolean') return clause;
  return prefixCondition(clause, namePrefix);
}

/** Prefix all field-level conditions for repeatable / row-scoped namePrefix mode. */
export function prefixFieldConditions(field: FormFieldMapping, namePrefix?: string): FormFieldMapping {
  if (!namePrefix) return field;

  const result = { ...field };
  if (result.when) {
    result.when = { ...result.when };
    if (result.when.visible) result.when.visible = prefixCondition(result.when.visible, namePrefix);
    if (result.when.required) result.when.required = prefixCondition(result.when.required, namePrefix);
    result.when.disabled = maybePrefixWhenClause(result.when.disabled, namePrefix);
    result.when.readOnly = maybePrefixWhenClause(result.when.readOnly, namePrefix);
    if (result.when.adapterHint) {
      result.when.adapterHint = {
        ...result.when.adapterHint,
        condition: prefixCondition(result.when.adapterHint.condition, namePrefix),
      };
    }
    if (result.when.formatter) {
      result.when.formatter = {
        ...result.when.formatter,
        condition: prefixCondition(result.when.formatter.condition, namePrefix),
      };
    }
  }

  if (result.conditionalVisible) {
    result.conditionalVisible = prefixCondition(result.conditionalVisible, namePrefix);
  }
  if (result.conditionalRequired) {
    result.conditionalRequired = prefixCondition(result.conditionalRequired, namePrefix);
  }
  if (result.conditionalDisabled) {
    result.conditionalDisabled = prefixCondition(result.conditionalDisabled, namePrefix);
  }
  if (result.conditionalAdapterHint) {
    result.conditionalAdapterHint = {
      ...result.conditionalAdapterHint,
      condition: prefixCondition(result.conditionalAdapterHint.condition, namePrefix),
    };
  }

  return result;
}
